var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev-domains"},_vm._l((_vm.domainsList),function(item,index){return _c('div',{key:index,attrs:{"type":"info","size":"mini"}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }